import { IFinalizarLoteRequisicaoCompraUseCase } from "../../../presentation/useCases/update/finalizar_lote_requisicao_compra_use_case";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * FinalizarLoteRequisicaoCompraUseCase
 */

export class FinalizarLoteRequisicaoCompraUseCase implements IFinalizarLoteRequisicaoCompraUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async finalizarLoteRequisicaoCompra(
    setRequisicaoCompra: Set<string | number>,
  ): Promise<void> {
    const idsRequisicaoCompra = Array.from(setRequisicaoCompra).map(x => {
      if (typeof x === 'string') return Number(x);
      if (typeof x === 'number') return x;
      throw new Error('Id de requisição invalido!');
    })

    await this.repository.finalizarLoteRequisicaoCompra(
      idsRequisicaoCompra,
    );
  }
}
